module.exports = "/images/cmrad_logo_round.png?c44a348f6a9f606e0a3ef39f43d2f14a";